import { render } from "./Country.vue?vue&type=template&id=87711730"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"

import "./Country.vue?vue&type=style&index=0&id=87711730&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__